import { useSearchParams } from 'react-router-dom';
import { getAvatarConfig } from './avatar-configs';
import { UnifiedAvatarCall } from './UnifiedAvatarCall';
import { LiveKitAvatarCall } from './LiveKitAvatarCall';

export function AvatarVideoCall() {
  const [searchParams] = useSearchParams();
  const companyCode = searchParams.get('company') || 'boi';
  const engine = searchParams.get('engine') || 'heygen';

  // Get company configuration
  let config;
  try {
    config = getAvatarConfig(companyCode);
  } catch (error) {
    // If invalid company, redirect to BOI
    window.location.href = '/avatar?company=boi';
    return null;
  }

  if (engine === 'livekit') {
    return <LiveKitAvatarCall companyConfig={config} />;
  }

  return <UnifiedAvatarCall companyConfig={config} mode="video" />;
}
